module.exports = __webpack_public_path__ + "static/media/1Phone-SVG.d37c48da.svg";